export const CREATE_TICKET_PATH = '/communicator/create-ticket';
